// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__25fQN","dragIcon":"Choice_dragIcon__2CgQB","left":"Choice_left__3e0bO","input":"Choice_input__D4FZb"};